<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM7,3C7,3,9,3,9,3C9,3,9,5,9,5C9,5,7,5,7,5C7,5,7,3,7,3C7,3,7,3,7,3ZM10,13C10,13,6,13,6,13C6,13,6,12,6,12C6,12,7,12,7,12C7,12,7,7,7,7C7,7,6,7,6,7C6,7,6,6,6,6C6,6,9,6,9,6C9,6,9,12,9,12C9,12,10,12,10,12C10,12,10,13,10,13C10,13,10,13,10,13Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'InfoSign',
} as DefineComponent
</script>
